import React from 'react';

import Storage from '@aws-amplify/storage';
import awsconfig from './aws-exports';


Storage.configure(awsconfig);

class S3ImageUpload extends React.Component {
    
    onChange(e) {
        const file = e.target.files[0];
        const key = this.props.productId + '/product.jpg';
        Storage.put(key, file, {
            contentType: 'image/png'
        })
        .then (async ()=>{
            if(this.props.onSubmit){
                let event = {
                    target:
                    {
                        name: "imageUrl", 
                        value: await Storage.get(key)
                    }
                }
                this.props.onSubmit(event);
            }
        }
        )
        .catch(err => console.log(err));

    }
  
    render() {
        
        return (
            <input
                type="file" accept='image/*'
                onChange={(e) => this.onChange(e)}
            />
        )
    }
  }

export default S3ImageUpload


// WEBPACK FOOTER //
// ./src/S3ImageUpload.js